// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_mats_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Bring the air cushion to your workspace. Stand active at your desk.`
};

const el_tech_mats_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Φέρτε το αερόστρωμα στο χώρο εργασίας σας. Σταθείτε ενεργά στο γραφείο σας.`
};

const ru_tech_mats_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Принесите воздушную подушку на рабочее место. Стойте активно за столом.`
};

const he_tech_mats_desc = /** @type {(inputs: {}) => string} */ () => {
	return `הביאו את כרית האוויר למקום העבודה. עמדו בצורה פעילה ליד השולחן.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_mats_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_mats_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_mats_desc", locale)
	if (locale === "en") return en_tech_mats_desc(inputs)
	if (locale === "el") return el_tech_mats_desc(inputs)
	if (locale === "ru") return ru_tech_mats_desc(inputs)
	if (locale === "he") return he_tech_mats_desc(inputs)
	return "tech_mats_desc"
};